module.exports = __webpack_public_path__ + "img/img_level_18.50216c3b.png";